import React, { useRef } from "react";

export default function PhotoField({ label, required, file, current, onChange }) {
  const cameraRef = useRef(null);
  const galleryRef = useRef(null);
  const pickerPosition = useRef(null);
  const openPicker = (input, button) => {
    pickerPosition.current = { x: window.scrollX, y: window.scrollY, button };
    input.current?.click();
  };
  const restorePosition = () => {
    const position = pickerPosition.current;
    if (!position) return;
    requestAnimationFrame(() => {
      position.button?.focus({ preventScroll: true });
      window.scrollTo(position.x, position.y);
    });
  };
  const select = (event) => {
    const next = event.target.files?.[0];
    event.target.value = "";
    restorePosition();
    // Cancelling a picker must preserve the previously selected photo.
    if (!next) return;
    if (next.size > 15 * 1024 * 1024) {
      window.alert("Fotoğraf en fazla 15 MB olabilir.");
      return;
    }
    onChange(next);
  };
  const buttonClass = file || current?.url ? "photo-button selected" : "photo-button";
  return <div className="photo-field">
    <span>{label}{required ? " *" : ""}</span>
    <input ref={cameraRef} required={!!required && !file && !current?.url} aria-label={`${label} kamera`} className="photo-input" type="file" accept="image/*" capture="environment" onChange={select} onCancel={restorePosition} />
    <input ref={galleryRef} aria-label={`${label} galeri`} className="photo-input" type="file" accept="image/*" onChange={select} onCancel={restorePosition} />
    <button type="button" className={buttonClass} onClick={(event) => openPicker(cameraRef, event.currentTarget)}>Fotoğraf Çek</button>
    <button type="button" className={buttonClass} onClick={(event) => openPicker(galleryRef, event.currentTarget)}>Galeriden / Dosyadan Seç</button>
    <small>{file ? `Seçildi: ${file.name}` : current?.url ? <a href={current.url} target="_blank" rel="noreferrer">Yüklü fotoğrafı görüntüle</a> : required ? "Bu MTA için zorunlu" : "İsteğe bağlı"}</small>
  </div>;
}
